function PlusIcon() {
    return (
        <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M6 16H26' stroke='#A8A29E' strokeWidth='2' strokeLinecap='round' />
            <path d='M16 26V6' stroke='#A8A29E' strokeWidth='2' strokeLinecap='round' />
        </svg>
    );
}

export default PlusIcon;
